import {
  Box,
  CircularProgress,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { getOutletList, switchOutlet } from "../../../services/outletApi";
import { logout, setUser } from "../../../redux/features/auth/authSlice";
import { SIDEBAR_URL } from "../../constants/constant";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalSelectOutlet = ({ open, setOpen, dataLogin }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedOutlet, setSelectedOutlet] = useState(null);

  const handleClose = () => {
    setOpen(false);
    dispatch(logout());
  };

  const getPath = (data) => {
    const matched = SIDEBAR_URL.find((item) =>
      data.detail.roles.includes(Number(item.id)),
    );

    return matched ? matched.path : "/profile"; // fallback
  };

  const handleSelect = () => {
    if (!dataLogin) handleClose();
    mutateSwitchOutlet({ company_id: Number(selectedOutlet) });
  };

  const { data: dataOutlet, isFetching: isFetchingOutlet } = useQuery({
    queryFn: () => getOutletList(),
    queryKey: ["outlets", dataLogin],
    refetchOnWindowFocus: false,
    enabled: dataLogin !== undefined && dataLogin !== null,
  });

  const { mutate: mutateSwitchOutlet, isLoading } = useMutation({
    mutationFn: switchOutlet,
    onSuccess: (data) => {
      if (data === undefined) return;
      dispatch(
        setUser({
          accessTokenOfficeOlin: data.token.access,
          accessExpired: data.token.access_expired,
          renewTokenOfficeOlin: data.token.renew,
          renewExpired: data.token.renew_expired,
          img_profile: data.foto_profile,
          name: data.nama_lengkap,
          job: data.title_name,
          status_code: data.status_code,
          status_code_user: data.status_code_user,
          title: data.title,
          company_id: data.company_id,
          company_name: data.company_name,
          roles: data.roles,
          package: data.package,
          is_tax_free: data.is_tax_free,
          is_psef: data.is_psef,
        }),
      );

      if (Cookies.get("accessTokenOfficeOlin") !== undefined || null || "") {
        var path = getPath(dataLogin);
        navigate(dataLogin.detail.title === 1 ? "/purchase-pbf" : path);
      } else {
        navigate("/login");
      }
    },
  });

  useEffect(() => {
    if (dataLogin) setSelectedOutlet(dataLogin.detail.company_id);
  }, [dataLogin]);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            maxWidth: "75%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "70vh",
            padding: 0,
          }}
          className="text-left text-[12px] w-3/4 lg:w-1/3"
        >
          <div className="px-8 py-4 sticky top-0">
            <p className="font-bold text-[16px]">
              Silahkan pilih outlet yang ingin anda pakai
            </p>
          </div>

          <hr />

          <div className="max-h-[50vh] overflow-y-auto">
            {dataOutlet &&
            dataOutlet.filter((item) => item.is_assigned).length > 0 &&
            !isFetchingOutlet ? (
              <RadioGroup
                value={selectedOutlet}
                onChange={(e) => {
                  setSelectedOutlet(e.target.value);
                }}
              >
                {dataOutlet
                  .filter((item) => item.is_assigned)
                  .map((item, i) => (
                    <div
                      className={`px-4 py-2 text-[12px] ${
                        i === 0 ? "" : "border-t"
                      }`}
                      key={i}
                    >
                      <FormControlLabel
                        value={item.company_id}
                        label={
                          <div>
                            <p className="text-[14px]">{item.company_name}</p>
                            <p className="text-gray-400 text-[12px]">
                              {item.company_address}
                            </p>
                          </div>
                        }
                        control={<Radio sx={{ fontSize: 12 }} />}
                        sx={{
                          width: "100%",
                          fontSize: 12,
                        }}
                      />
                    </div>
                  ))}
              </RadioGroup>
            ) : (
              <div className="flex items-center justify-center py-4">
                {isFetchingOutlet ? (
                  <CircularProgress size={20} />
                ) : (
                  "Anda tidak memiliki outlet, silahkan hubungi owner"
                )}
              </div>
            )}
          </div>
          <hr />
          <div className="flex items-center gap-4 px-8 py-2 sticky bottom-0 z-50">
            <button
              type="button"
              className="w-full rounded-md border-2 rounded hover:bg-gray-300 hover:text-white p-2 disabled:bg-gray-300 disabled:text-white"
              disabled={isFetchingOutlet || isLoading}
              onClick={handleClose}
            >
              Batal
            </button>
            <button
              type="button"
              className="w-full rounded-md bg-blue-500 text-white hover:bg-gray-300 p-2 disabled:bg-gray-300 disabled:text-white"
              disabled={isFetchingOutlet || isLoading}
              onClick={handleSelect}
            >
              {isLoading ? <CircularProgress size={10} /> : "Pilih Outlet"}
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default ModalSelectOutlet;
